import { render } from "./LibraryEdit.vue?vue&type=template&id=0b0a1171"
import script from "./LibraryEdit.vue?vue&type=script&lang=js"
export * from "./LibraryEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__